import React, { useEffect, useState } from "react";
import { numberWithCommas } from "../../../common/utils/app.utils";
import "./kamPriceNegotation.scss";

const KamPriceNegotation = ({selectedPlan,selectedHardwareType,ipAttributeType,pnqPayload}) => {
    let lineItems=pnqPayload && pnqPayload.lineItems && pnqPayload.lineItems.length> 0 && pnqPayload.lineItems[0];
    let standardRate=selectedPlan && selectedPlan.standardRate=== false ? false : lineItems && lineItems.plan && lineItems.plan.standardRate ? lineItems.plan.standardRate : false;
    const [capexValue,setCapexValue]=useState(null);
    useEffect(() => {
      setCapexTotalValue()
    }, []);
    const setCapexTotalValue = () =>{
      let lineItemsValue=pnqPayload && pnqPayload.lineItems && pnqPayload.lineItems.length> 0 && pnqPayload.lineItems[0];
      let siteSpecs=lineItemsValue && lineItemsValue.plan && lineItemsValue.plan.site && lineItemsValue.plan.site.length > 0 && lineItemsValue.plan.site[0] && lineItemsValue.plan.site[0].siteSpecs;
      let totalCpaxValue=0;
      if(siteSpecs && siteSpecs.length > 0){
        for (let i=0; i < siteSpecs.length; i++) {
          if(siteSpecs[i].name==="totalBoqCost"){
            totalCpaxValue=parseInt(siteSpecs[i].value)
          } else if(siteSpecs[i].name=== 'dftArc' || siteSpecs[i].name=== 'dftOtc'){
           // totalCpaxValue=totalCpaxValue+parseInt(siteSpecs[i].value);
           totalCpaxValue=0;
          }
        }
      }
      setCapexValue(totalCpaxValue);
    }
    return (
      <React.Fragment>
        {
          !standardRate || ipAttributeType || (selectedHardwareType && selectedHardwareType.value=== 'NON_STANDARD') || capexValue || (selectedPlan && selectedPlan.price && selectedPlan.price.amount === 0) ?
            <div className="kam_price_negotation">
              <ul>
                {
                  capexValue ?
                  <li>
                    <div class="alert_icon">
                      <div class="material-icons">warning_amber</div>
                      <div className="tooltip">Add CAPEX charges to one-time charge, if applicable. </div>
                    </div>
                    CAPEX charges: ₹{numberWithCommas(capexValue)}
                  </li>
                  :
                  ''
                }
                
                {
                  !standardRate &&
                  <li>
                    <div class="alert_icon">
                      <div class="material-icons">warning_amber</div>
                      <div className="tooltip">Pricing done according to Customer Agreed Rate Cards.</div>
                    </div>
                    Customer Agreed Rate Card
                  </li>
                }
                
                {
                  ipAttributeType &&
                    <li>
                      <div class="alert_icon">
                        <div class="material-icons">warning_amber</div>
                        <div className="tooltip">Selected configurations contain non-standard IP attributes. </div>
                      </div>
                      Non-Standard IP attributes
                    </li> 
                }
                
                {
                    selectedHardwareType && selectedHardwareType.value=== 'NON_STANDARD' &&
                    <li>
                      <div class="alert_icon">
                        <div class="material-icons">warning_amber</div>
                        <div className="tooltip">Customer has selected non-standard hardware.</div>
                      </div>
                      Non-Standard Hardware
                    </li>
                }
                {
                  selectedPlan && selectedPlan.price && selectedPlan.price.amount === 0 &&
                    <li>
                      <div class="alert_icon">
                        <div class="material-icons">warning_amber</div>
                        <div className="tooltip">Customer-agreed rate card does not have the selected bandwidth plan. </div>
                      </div>
                      Plan missing in Customer Agreed Rate Card
                    </li>
                }
               
              </ul>
          </div>
          :
          ''
        }
          
      </React.Fragment>
        
    );
};
export default KamPriceNegotation;
